import { render, staticRenderFns } from "./ComplementaryInformations.vue?vue&type=template&id=356ddc1e&"
import script from "./ComplementaryInformations.vue?vue&type=script&lang=js&"
export * from "./ComplementaryInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports